import formatISO from '@teetsh/app/src/utils/time/formatISO';
import {
  Appel,
  AppelApi,
} from '@teetsh/app/src/containers/RegistreAppel/types/appel';
import deserializeDateFromServer from '@teetsh/app/src/utils/time/deserializeDateFromServer';
import parseISO from '@teetsh/app/src/utils/time/parseISO';
import serializeDateToServer from '@teetsh/app/src/utils/time/serializeDateToServer';

export function serializeAppel(appel: Appel, tz: string): AppelApi {
  return {
    ...appel,
    date: formatISO(serializeDateToServer(appel.date, tz)),
  };
}

export function deserializeAppel(appel: AppelApi, tz: string) {
  const date = deserializeDateFromServer(parseISO(appel.date), tz);
  return {
    ...appel,
    date,
  };
}
